import { useEffect } from 'react';
import TipoGanadoForm from '../../components/tipos-ganado/TipoGanadoForm';
import {
  useTiposGanadoStore,
  type RegistrarTipoGanado
} from '../../stores/tipos-ganado/tipos-ganado.store';

const AgregarTipoGanado = () => {
  const { current: tipo, nuevo, registrar } = useTiposGanadoStore((state) => state);

  useEffect(() => {
    nuevo();
  }, []);

  const handleSave = (values: RegistrarTipoGanado) => {
    return registrar(values);
  };

  return <TipoGanadoForm esAgregar={true} tipo={tipo} onSave={handleSave} />;
};

export default AgregarTipoGanado;
